export function formatBytes(bytes: number, decimals = 1): string {
  if (bytes === 0) {
    return '0';
  }

  const k = 1000;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['bytes', 'Kb', 'Mb', 'Gb'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}
